<div class="chart">
  <div id="canvas-container" [style.height.px]="height">
    <canvas #chartCanvas></canvas>
  </div>
</div>
